import React, { useState, useLayoutEffect, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Modal,
    Card,
    CardContent,
    CardActions,
    Grid,
    Typography,
    TextField, 
    InputAdornment,
    Switch,
    Button,
    colors
} from '@material-ui/core';
import { reallocate_timeslots } from '../../../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)', 
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%'
    },

    container: {
        marginTop: theme.spacing(3)
    },

    actions: {
        justifyContent: 'flex-end'
    },

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    }
}));

export default function Reallocate(props) {

    const { open, onClose, max_appointment,agencies, className, ...rest } = props;

    const classes = useStyles();

    const [formState, setFormState] = useState({});




    const handleFieldChange = event => {
        event.persist();
        setFormState(formState => ({
            ...formState,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        }));
    };

    useEffect(() => {
        console.log('timeslot ' , props.timeslot_id); 
        var temp_val = {};
        for (let i = 0; i < agencies.length; i++) {
            temp_val['agency_' + agencies[i].agency_id] = agencies[i].max_appointment;
        }
        setFormState({
            ...formState,
            ...temp_val,
            date: props.date,
            timeslot_id: props.timeslot_id
        });
        
    },[props]);

    const handleSubmit = async event =>{
        event.preventDefault();

        let total_bookings = 0;
        for(let i = 0; i < agencies.length; i++){
            total_bookings += parseInt(formState['agency_' + agencies[i]['agency_id']]);
        }
        if(total_bookings > max_appointment){
            alert("Cannot exceed " + max_appointment + " slots");
            return;
        }
        let data = await reallocate_timeslots(formState);
        if(data){
            onClose();
        }
        console.log(formState);
    };

    return (
        <Modal
            onClose={onClose}
            open={open}
        >
            <Card
                {...rest}
                className={clsx(classes.root, className)}
            >
                <form onSubmit={handleSubmit}>
                    <CardContent>
                        <Typography
                            align="center"
                            gutterBottom
                            variant="h5"
                        >
                            Re-allocate
                    </Typography>
                        <Grid
                            className={classes.container}
                            container
                            spacing={4}
                        >
                            {agencies.map((agency) => (
                                <Grid
                                    item
                                    md={4}
                                    xs={12}
                                >
                                    <TextField
                                        fullWidth
                                        
                                        label={agency.name}
                                        name={'agency_' + agency.agency_id}
                                        onChange={handleFieldChange}
                                        value={formState['agency_' + agency.agency_id]}
                                        variant="outlined"
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Button
                            onClick={onClose}
                            variant="contained"
                        >
                            Close
                    </Button>
                        <Button
                            className={classes.saveButton}
                            type="submit"
                            variant="contained"
                        >
                            Save
                    </Button>
                    </CardActions>
                </form>
            </Card>
        </Modal>
    )
}
